import React from 'react';
import { useHistory } from 'react-router-dom';

import { getCities } from '../../../api/getCities';
import { getPlayersMoto } from '../../../api/getPlayersMoto';
import * as func from '../../../utils/funcs';
import * as Cookies from '../../../utils/cookies';

import PlayerImg from './../../../graphics/elements/profile_photo.svg';
import styles from './SignupForm.module.css';
import { useGetAppLinks } from '../../../hooks/useGetAppLinks';
import PrimaryButton from './../../../partials/PrimaryButton';
import { registerNewUser } from '../../../api/registerNewUser';
import { registerNewPlayer } from '../../../api/registerNewPlayer';
import { addPicPlayer } from '../../../api/addPicPlayer';
import { getUserPlayerInfo } from '../../../api/getUserPlayerInfo';

function SignupForm(props) {

  const { user, setUser, stage,  setIsFixedCss, invited } = props;

  const history = useHistory();

  const { signIn } = useGetAppLinks();
  const [signupUser, setSignupUser] = React.useState(user);


  const [inStage, setInStage] = React.useState(stage);
  const [cities, setCities] = React.useState([]);
  const [motos, setMotos] = React.useState([]);


  const [textError, setTextError] = React.useState('');
  
  // Loading states
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const [isSettingProfile, setIsSettingProfile] = React.useState(false);
  const [isUploadingPicture, setIsUploadingPicture] = React.useState(false);


  const [fName, setFName] = React.useState('');
  const [lName, setLName] = React.useState('');
  const [phone, setPhone] = React.useState('');
  const [pass, setPass] = React.useState('');
  const [passCheck, setPassCheck] = React.useState('');
  const [term, setTerm] = React.useState(false);


  const [sentence, setSentence] = React.useState('');
  const [city, setCity] = React.useState('');
  const [school, setSchool] = React.useState('');
  const [grade, setGrade] = React.useState('');
  const [shirtSize, setShirtSize] = React.useState('');


  const [profilePic, setProfilePic] = React.useState(null);


  React.useEffect(() => {
    let mounted = true;

    getCities().then(data => {
      if (data.error) {

      } else if (mounted) {
        setCities(data);
      }
    });

    return function cleanup() {
      mounted = false;
    };
  }, []);

  React.useEffect(() => {
    let mounted = true;

    getPlayersMoto().then(data => {
      if (data.error) {

      } else if (mounted) {
        setMotos(data);
      }
    });

    return function cleanup() {
      mounted = false;
    };
  }, []);


  React.useEffect(() => {
    let mounted = true;

    const token = Cookies.getToken();
    if (token && inStage) {
       getUserPlayerInfo().then(data => {
         if (data.error) {

         } else {
           if (mounted) {
            if (data.player !== null) {
              setCity(data.player.city);
            }
          }
        }
      });
    }

    return function cleanup() {
      mounted = false;
    };
  }, [inStage]);



  const badNumber = num => {

    if (num.length !== 10) {
      return true;
    }

    for (let i = 0; i < num.length; i++) {
      if (isNaN(parseInt(num[i]))) {
        return false;
      }
    }

    if (num[0] !== '0') {
      return true;
    }

    return false;
  };


  const badWord = word => {

    if (word.length < 2) {
      return true;
    }



    return false;
  };


  const didNotPick = check => check === '';


  const didNotPickPic = check => check === null;

  const handleNext = async () => {
    if (inStage === 1) {
      if (passCheck !== pass) {
        setTextError('הססמאות אינן תואמות');
      } else if (badNumber(phone)) {
        setTextError('יש להזין מספר סלולרי תקין');
      } else if (badWord(fName)) {
        setTextError('שם פרטי אינו תקין');
      } else if (badWord(lName)) {
        setTextError('שם משפחה אינו תקין');
      } else if (pass.length < 5 || passCheck.length < 5) {
        setTextError('סיסמה קצרה - לפחות 5 תווים');
      } else if (term === false) {
        setTextError('יש לאשר את התקנון כדי להירשם לטורניר');
      } else {
        setTextError('');
        setIsSubmitting(true);
        try {
          const resNewUser = await registerNewUser(phone, fName, lName, pass);
          if (!resNewUser.error) {
            setUser(await getUserPlayerInfo());
            setInStage(2);
            setTimeout(() => {
              history.push('/signup/2');
            }, 600);
          } else {
            setTextError('מספר טלפון זה כבר קיים במערכת');
          }
        } catch (error) {
          setTextError('אירעה שגיאה, נסה שוב');
        } finally {
          setIsSubmitting(false);
        }
      }
    } else if (inStage === 2) {
      if (didNotPick(city)) {
        setTextError('לא בחרת עיר');
      } else if (didNotPick(grade)) {
        setTextError('לא בחרת כיתה');
      } else if (badWord(school)) {
        setTextError('שם בית ספר לא תקין');
      } else if (didNotPick(sentence)) {
        setTextError('לא בחרת מוטו לחיים');
      } else if (didNotPick(shirtSize)) {
        setTextError('לא בחרת מידת חולצה');
      } else {
        setTextError('');
        setIsSettingProfile(true);
        try {
          await registerNewPlayer(signupUser.id, sentence, city, school, grade, shirtSize);
          setUser(await getUserPlayerInfo());
          setInStage(3);
          setTimeout(() => {
            history.push('/signup/3');
          }, 600);
        } catch (error) {
          setTextError('אירעה שגיאה, נסה שוב');
        } finally {
          setIsSettingProfile(false);
        }
      }
    } else if (inStage === 3) {
      setTextError('');
      setIsUploadingPicture(true);
      try {
        if (!didNotPickPic(profilePic)) {
          await addPicPlayer(signupUser.id, profilePic);
          const tempUser = await getUserPlayerInfo();
          setSignupUser(tempUser);
          setUser(tempUser);
        }
        history.push('/redirect');
      } catch (error) {
        setTextError('אירעה שגיאה בהעלאת תמונה');
      } finally {
        setIsUploadingPicture(false);
      }
    }
  };


  const handleFocus = answer => {
    if (!func.deviceIsIphone()) {
      setIsFixedCss(answer);
    }
  };

  const handleClickTerm = () => {
    history.push('/signup/term');
  };

  return (<div
      className={`${styles.signupForm} ${inStage === 1 ? styles.stage1 :
        inStage === 2 ? styles.stage2 : styles.stage3}`}
    >
      {}
      <form className={styles.signupFormSection}>
        <input
          type="text"
          value={fName}
          onChange={e => setFName(e.target.value)}
          placeholder="שם פרטי"
          required={true}
          onFocus={() => handleFocus(true)}
          onBlur={() => handleFocus(false)}
        />
        <input
          type="text"
          value={lName}
          onChange={e => setLName(e.target.value)}
          placeholder="שם משפחה"
          required={true}
          onFocus={() => handleFocus(true)}
          onBlur={() => handleFocus(false)}
        />
        <input
          type="tel"
          value={phone}
          onChange={e => setPhone(e.target.value)}
          placeholder="נייד"
          required={true}
          onFocus={() => handleFocus(true)}
          onBlur={() => handleFocus(false)}
        />
        <input
          type="password"
          value={pass}
          onChange={e => setPass(e.target.value)}
          placeholder="סיסמה"
          minLength="5"
          required={true}
          onFocus={() => handleFocus(true)}
          onBlur={() => handleFocus(false)}
        />
        <input
          type="password"
          value={passCheck}
          onChange={e => setPassCheck(e.target.value)}
          placeholder="וידוא סיסמה"
          minLength="5"
          required={true}
          onFocus={() => handleFocus(true)}
          onBlur={() => handleFocus(false)}
        />
        <span className={styles.errorMsg}>{textError}</span>
        <span className={styles.termCheck}>
          <input
            type="checkbox"
            id="termAgree"
            name="termAgree"
            value={term}
            onChange={() => setTerm(s => !s)}
          />
          <label htmlFor="termAgree">
            מאשר את <span onClick={handleClickTerm}>תקנון השימוש</span>
          </label>
        </span>
        <PrimaryButton
          text="יצירת משתמש"
          onClick={handleNext}
          loading={isSubmitting}
          disabled={isSubmitting || !term}
          size="large"
          className={styles.marginTop}
          type="button"
        />

        <span
          className={`btnMedium ${styles.signinPlayers}`}
          onClick={() => {
            history.push(signIn);
          }}
        >
          כניסה לשחקנים רשומים
        </span>
      </form>

      {}
      <form className={styles.signupFormSection}>
        <select
          name="city"
          value={city}
          onChange={e => setCity(e.target.value)}
          required={true}

        >
          <option value="" hidden>
            עיר
          </option>
          {cities.map(city => {
            return (<option key={city.id} value={city.id}>
                {city.name}
              </option>);
          })}
        </select>

        <select
          name="grade"
          value={grade}
          onChange={e => setGrade(e.target.value)}
          required={true}

        >
          <option value="" hidden>
            כיתה
          </option>
          <option value={4}>ד'</option>
          <option value={5}>ה'</option>
          <option value={6}>ו'</option>
          <option value={7}>ז'</option>
          <option value={8}>ח'</option>
          <option value={9}>ט'</option>
          <option value={10}>י'</option>
          <option value={11}>יא'</option>
          <option value={12}>יב'</option>
          <option value={13}>בוגרים</option>
        </select>

        <input
          type="text"
          value={school}
          onChange={e => setSchool(e.target.value)}
          placeholder="בית ספר"
          required={true}
          onFocus={() => handleFocus(true)}
          onBlur={() => handleFocus(false)}
        />

        <select
          name="moto"
          value={sentence}
          onChange={e => setSentence(e.target.value)}
          required={true}

        >
          <option value="" hidden>
            מוטו לחיים
          </option>
          {motos.map(moto => (<option key={moto.id} value={moto.text}>
              {moto.text}
            </option>))}
        </select>

        <select
          name="shirtSize"
          value={shirtSize}
          onChange={e => setShirtSize(e.target.value)}
          required={true}

        >
          <option value="" hidden>
            מידת חולצה
          </option>
          <option value="S">S</option>
          <option value="M">M</option>
          <option value="L">L</option>
          <option value="XL">XL</option>
          <option value="XXL">XXL</option>
        </select>

        <span className={styles.errorMsg}>{textError}</span>

        <PrimaryButton
          text="הגדרת פרופיל"
          onClick={handleNext}
          loading={isSettingProfile}
          disabled={isSettingProfile}
          size="large"
          className={styles.marginTop}
          type="button"
        />
      </form>

      {}
      <form className={styles.signupFormSection}>
        {!profilePic ? (<img src={PlayerImg} width="90%" alt="הכנסת תמונת פרופיל" />) :
          (<img
              src={URL.createObjectURL(profilePic)}
              id="playerImgPicked"
              className={styles.playerImg}
              alt="תמונת השחקן"
            />)}

        <input
          className="hideMe"
          id="pickProfilePic"
          type="file"
          accept="image/png, image/jpeg"
          onChange={e => setProfilePic(e.target.files[0])}
        />

        <div
          className="btnMedium"
          onClick={() => document.querySelector('#pickProfilePic').click()}
        >
          העלאת תמונה
        </div>

        <span className={styles.errorMsg}>{textError}</span>

        <PrimaryButton
          text="סיום"
          onClick={handleNext}
          loading={isUploadingPicture}
          disabled={isUploadingPicture}
          size="large"
          className={styles.marginTop}
          type="button"
        />

        <PrimaryButton
          text="המשך ללא תמונת שחקן"
          onClick={handleNext}
          loading={isUploadingPicture}
          disabled={isUploadingPicture}
          size="medium"
          className={styles.marginTop}
          type="button"
        />
        {}
      </form>
    </div>);
}

export default SignupForm;




